module.exports = __webpack_public_path__ + "static/causes-0146aeaafe21fed8528f5f0528ce55c5.png";